import React from 'react'
import ListWrapper from 'redesign/components/organisms/ListWrapper'
import AnnouncementCard from 'redesign/components/organisms/announcement-card'
import type { AnnouncementsListProps } from './types'

const AnnouncementsList: React.FC<AnnouncementsListProps> = ({
  isLoading,
  announcements,
  loadMore,
  showLoadMoreButton,
  handleClick,
}) => (
  <ListWrapper
    hasContent={Boolean(announcements?.length)}
    isLoading={isLoading}
    showLoadMoreButton={showLoadMoreButton}
    loadMore={loadMore}
    buttonTestId="announcements-load-more"
  >
    {announcements?.map((announcement) => (
      <AnnouncementCard
        key={announcement.announcementId}
        announcement={announcement}
        onClick={() => handleClick(announcement)}
      />
    ))}
  </ListWrapper>
)

export default AnnouncementsList
